import { CallToAction } from "#models/outcome";
import { ECallToActionType } from "#models/questionnaire";

export const handleClick = (item: CallToAction, videoUrl?: string) => {
  if (item.type === ECallToActionType.ViewDetails) {
    return;
  }
  if (item.type === ECallToActionType.Video && videoUrl?.length) {
    if (!String(videoUrl).startsWith('http')) {
      videoUrl = '//' + videoUrl;
    }
    window.open(videoUrl, '_blank');
    return;
  }
  if (item.type === ECallToActionType.URL) {
    if (!item.value.match(/^https?:\/\//i)) {
      item.value = 'http://' + item.value;
    }
    window.open(item.value, '_blank')?.focus();
    return;
  }
  if (item.type === ECallToActionType.Email) {
    window.location.href = `mailto:${item.value}`;
    return;
  }
  if (item.type === ECallToActionType.Phone) {
    window.location.href = 'tel:' + item.phoneCode + item.value;
    return;
  }
};
